import { l as i, v as s } from "./index-64063129.js";
var l = function() {
  for (var t = [], r = 0; r < arguments.length; r++)
    t[r] = arguments[r];
  var o = {}, a = function(e) {
    return typeof e == "object" ? Object.keys(e).forEach(function(n) {
      o[n] = e[n];
    }) : o[e] = !0;
  }, c = function(e) {
    return e.filter(function(n) {
      return n !== !0 && !!n;
    }).map(function(n) {
      return Array.isArray(n) ? c(n) : a(n);
    });
  };
  return c(t), Object.keys(o).map(function(e) {
    return o[e] && e || null;
  }).filter(function(e) {
    return e !== null;
  }).join(" ");
};
function f(t) {
  if (typeof i < "u")
    s(t);
  else {
    var r = "License activation failed for ".concat(t.name, `
`);
    r += `The @progress/kendo-licensing script is not loaded.
`, r += "See ".concat(t.licensingDocsUrl, ` for more information.
`), console.warn(r);
  }
}
var d = {
  name: "@progress/kendo-react-indicators",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1695802323,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
};
export {
  l as c,
  d as p,
  f as v
};
